export type WebhookEventType =
  | "flow_instance.created"
  | "flow_instance.submitted"
  | "flow_instance.unlocked"
  | "flow_instance.cancelled"
  | "flow_instance.reopened"
  | "flow_instance.completed"
  | "flow_instance.step_changed"
  | "client.created"
  | "client.updated"
  | "client.deleted"
  | "compliance.requested"
  | "compliance.approved"
  | "compliance.rejected"
  | "compliance.withdrawn"
  | "external_approval.requested"
  | "external_approval.approved"
  | "external_approval.rejected"
  | "external_approval.withdrawn"
  | "signature_order.created"
  | "signature_order.cancelled"
  | "signature_order.signed"
  | "pdf.generated"
  | "pdf.deleted"
  | "flow.created"
  | "flow.updated"
  | "flow.activated"
  | "flow.deactivated"
  | "flow.deleted";

/** The events a webhook can subscribe to, in display order. Labels: `webhook-dialog.i18n.ts` and `webhooks-table.i18n.ts`. */
export const WEBHOOK_EVENTS: readonly WebhookEventType[] = [
  "flow_instance.created",
  "flow_instance.submitted",
  "flow_instance.unlocked",
  "flow_instance.cancelled",
  "flow_instance.reopened",
  "flow_instance.completed",
  "flow_instance.step_changed",
  "client.created",
  "client.updated",
  "client.deleted",
  "compliance.requested",
  "compliance.approved",
  "compliance.rejected",
  "compliance.withdrawn",
  "external_approval.requested",
  "external_approval.approved",
  "external_approval.rejected",
  "external_approval.withdrawn",
  "signature_order.created",
  "signature_order.cancelled",
  "signature_order.signed",
  "pdf.generated",
  "pdf.deleted",
  "flow.created",
  "flow.updated",
  "flow.activated",
  "flow.deactivated",
  "flow.deleted",
];
